import { useFeatures, type WorkspaceFeatures } from "@expert/features";
import { useQuery } from "@tanstack/react-query";

import type { TechSupportMetrics } from "@/sales-tools/metrics/api/types";

import { getBusinessToday } from "./businessDay";
import { getYesterdayPerformanceMetrics } from "./getYesterdayPerformanceMetrics";

export interface YesterdayPerformanceMetrics {
    metrics: TechSupportMetrics | null;
    isLoading: boolean;
    isError: boolean;
}

export function useYesterdayPerformanceMetrics(): YesterdayPerformanceMetrics {
    const {
        features: { isMorningPaperEnabled },
    } = useFeatures<WorkspaceFeatures>();

    const { data, isLoading, isError } = useQuery({
        queryKey: ["morningPaper", "performanceMetrics", getBusinessToday()],
        queryFn: getYesterdayPerformanceMetrics,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        retry: 0,
        enabled: isMorningPaperEnabled,
    });

    return {
        metrics: data ?? null,
        isLoading,
        isError,
    };
}
